import React from "react";
import styled from "styled-components";
import { Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { faQuestionCircle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Lesson,
  didProfileCompleteLesson,
  visibleLessonAwards,
} from "../../common/api";
import { Account } from "../../common/context/AccountContext";
import { LessonImage } from "../../common/LessonImage";
import { COLOR_WHITE, COLOR_GRAY_DISABLED } from "../../common/colors";

const LockedAwardIcon = styled(FontAwesomeIcon)<{ $useWhiteIcons: boolean }>`
  height: 90%;
  color: ${({ $useWhiteIcons }) => ($useWhiteIcons ? COLOR_WHITE : COLOR_GRAY_DISABLED)};
  margin-right: 2px;
  padding: 1px;
`;

export const LessonBadges = ({
  height,
  lesson,
  account,
  useWhiteIcons,
  hideCompletion = false,
}: {
  height: string;
  lesson: Lesson;
  account: Account;
  useWhiteIcons: boolean;
  hideCompletion?: boolean;
}) => {
  const { t } = useTranslation();
  const isCompletionVisible = !hideCompletion && !lesson.web_content_url;
  return (
    <Stack style={{ height }} direction="horizontal">
      {visibleLessonAwards(
        lesson.awards,
        account.profileState?.unlocked_award_uuids || []
      ).map((award) => (
        <React.Fragment key={award.uuid}>
          {account.profileState?.unlocked_award_uuids.includes(award.uuid) ? (
            <LessonImage
              lazy
              thumbSize="small"
              url={award.image_url}
              style={{ width: "auto", height: "100%", marginRight: "2px" }}
              alt={t("award_content_description", {
                name: award.name,
                description: award.description,
              })}
            />
          ) : (
            <LockedAwardIcon
              icon={faQuestionCircle}
              $useWhiteIcons={useWhiteIcons}
            />
          )}
        </React.Fragment>
      ))}
      {isCompletionVisible && (
        <img
          src={
            didProfileCompleteLesson(
              account.profileState?.completed_lessons_info || {},
              lesson.id,
              lesson.custom_flashpack_id
            )
              ? `${process.env.PUBLIC_URL}/check-green.png`
              : useWhiteIcons
              ? `${process.env.PUBLIC_URL}/check-white.png`
              : `${process.env.PUBLIC_URL}/check-light-grey.png`
          }
          style={{ height: "100%" }}
          alt=""
        />
      )}
    </Stack>
  );
};
